import { render, staticRenderFns } from "./roleManager.vue?vue&type=template&id=42512ed2"
import script from "./roleManager.vue?vue&type=script&lang=js"
export * from "./roleManager.vue?vue&type=script&lang=js"
import style0 from "./roleManager.vue?vue&type=style&index=0&id=42512ed2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports